<template>
	<article class="content-article" id="mplus-entrance">
		<h1 class="screen_out">대문 미디어 컨텐츠</h1>
		<div :class="wrapClassName">
			<component
					v-for="layer in layers"
					:is="layer.type + '-layer'"
					:layer="layer"
					:type="type"
					:baseFontColor="baseFontColor"
			></component>
		</div>
	</article>
</template>
<script>
	import ImageLayer from './components/ImageLayer.vue';
	import VideoLayer from './components/VideoLayer.vue';
	import HtmlLayer from './components/HtmlLayer.vue';

	export default {
		components: {
			ImageLayer, VideoLayer, HtmlLayer
		},
		props: ['type', 'layers', 'baseFontColor'],
		computed: {
			wrapClassName() {
				return 'box_gate column_type' + this.type;
			}
		}
	}
</script>
